import React from "react";
import { JellyTriangle } from "@uiball/loaders";

const LoaderComponent = () => {
    return <JellyTriangle size={60} speed={1.75} color="black" />;
};

export default LoaderComponent;